import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

/**
 * The JSM Pending Journeys Route.
 * Pending Journeys: /jira/servicedesk/projects/:projectKey/journeys/pending
 */
export const pendingJourneysRoute: InvariantJiraRoute = {
	path: '/jira/servicedesk/projects/:projectKey/journeys/pending',
	name: 'journeys',
	exact: true,
};
